<template>
  <TimeslotDashboardLayout>
    <div class="main-content booking prof prof-booking-width">
      <div>
        <div class="content-div">
          <div class="tap-heading-div">
            <h1 class="tab-heading">Bookings</h1>
            <div class="tab-text">
              <div class="text-block-37">
                These are the bookings made by your clients. All booking times
                are based on your selected time zone
                <span class="text-span-2"
                  ><strong>{{ customerInfo.customerTimezone }}</strong></span
                >. To update
                <span class="link-6 click-margin" @click="openTime">
                  <strong>Click Here</strong>
                </span>
              </div>
            </div>
            <div class="no-update_wrapper" v-if="bookingInfoAlt.length === 0">
              <div class="no-update_content">
                <img
                  src="@/assets/timeslot-images/timer.svg"
                  loading="lazy"
                  alt=""
                  width="50"
                  height="50"
                />
                <div class="no-update-yet">Nothing to show here</div>
                <div class="appointments">
                  Appointments with clients would show up here
                </div>
                <!--                <a href="#" class="explore-professionals_button w-button"-->
                <!--                  >Explore professionals</a-->
                <!--                >-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="display: flex; justify-content: flex-end; margin-top:20px;"
        v-if="bookingInfoAlt.length !== 0"
      >
        <div class="filter-size">
          <FormulateInput
            type="select"
            name="bookingStatus"
            placeholder="All"
            style="color: black;"
            :options="['All', 'Client', 'Personal']"
            v-model="filterType"
          />
        </div>
      </div>
      <div
        data-current="Tab 2"
        data-easing="ease"
        data-duration-in="300"
        data-duration-out="100"
        class="tabs w-tabs"
        v-if="bookingInfoAlt.length !== 0"
        style="margin-top:0;"
      >
        <div class="tabs-menu-2 w-tab-menu">
          <a
            data-w-tab="Tab 2"
            :class="
              upcoming
                ? 'booking-tab w-inline-block w-tab-link w--current'
                : 'booking-tab w-inline-block w-tab-link'
            "
            @click="openUpcoming"
          >
            <div>Upcoming</div>
          </a>
          <a
            data-w-tab="Tab 3"
            :class="
              past
                ? 'booking-tab w-inline-block w-tab-link w--current'
                : 'booking-tab w-inline-block w-tab-link'
            "
            @click="openPast"
          >
            <div>Past</div>
          </a>
        </div>
        <div class="w-tab-content">
          <div
            data-w-tab="Tab 2"
            v-if="upcoming"
            :class="upcoming ? 'w-tab-pane w--tab-active' : 'w-tab-pane'"
          >
            <div class="no-update_wrapper" v-if="upcomingBookings.length === 0">
              <div class="no-update_content">
                <img
                  src="@/assets/timeslot-images/timer.svg"
                  loading="lazy"
                  alt=""
                  width="50"
                  height="50"
                />
                <div class="no-update-yet">
                  <strong>Nothing to show here</strong>
                </div>
                <div class="appointments">
                  <strong>No upcoming bookings</strong>
                </div>
                <!--                <router-link-->
                <!--                    to="/discover-professionals"-->
                <!--                    class="explore-professionals_button w-button"-->
                <!--                >Explore professionals</router-link-->
                <!--                >-->
              </div>
            </div>
            <div v-else>
              <div
                class="bookings-list-wrapper bookings"
                v-for="(upcomingBooking, index) in upcomingBookings"
                :key="index"
              >
                <div class="div-block-24-copy">
                  <div class="booking-heading">
                    <div class="text-block-24">
                      Consultation Session with
                      <router-link
                        v-if="upcomingBooking.type === 'PROFESSIONAL'"
                        :to="`/clients/${upcomingBooking.bookingCustomerId}`"
                        class="link-5"
                        >{{ upcomingBooking.customerName }}</router-link
                      >
                      <router-link
                        v-if="upcomingBooking.type === 'CUSTOMER'"
                        :to="
                          `/professionals/${upcomingBooking.bookingProfessionalId}`
                        "
                        class="link-5"
                        >{{ upcomingBooking.professionalName }}</router-link
                      >
                    </div>
                    <!--                    <div class="booking-details" @click="toggleUpcoming(index)">-->
                    <!--                      <strong-->
                    <!--                        >Details-->
                    <!--                        <img-->
                    <!--                          src="@/assets/timeslot-images/left.svg"-->
                    <!--                          loading="lazy"-->
                    <!--                          alt=""-->
                    <!--                          v-if="index !== isSelected && !upcomingOpen"-->
                    <!--                        />-->
                    <!--                        <img-->
                    <!--                          src="@/assets/timeslot-images/down-arrow.svg"-->
                    <!--                          loading="lazy"-->
                    <!--                          alt=""-->
                    <!--                          v-else-->
                    <!--                        />-->
                    <!--                      </strong>-->
                    <!--                    </div>-->
                  </div>

                  <div class="div-block-22">
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-7"
                      />
                      <div>
                        {{
                          new Date(
                            upcomingBooking.bookingStartTime.slice(0, 10)
                          )
                            .toString()
                            .slice(0, 11)
                        }}
                      </div>
                    </div>
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-8"
                      />
                      <!--                      {{ upcomingBooking.bookingStartTime.slice(10, 16) }}am - -->
                      <!--                      {{ upcomingBooking.bookingEndTime.slice(10, 16) }}am-->
                      <div>
                        {{
                          formatHours(
                            new Date(upcomingBooking.bookingStartTime)
                          )
                        }}:{{
                          formatMinutes(
                            new Date(upcomingBooking.bookingStartTime)
                          )
                        }}
                        {{
                          formatTime(new Date(upcomingBooking.bookingStartTime))
                        }}
                        -
                        {{
                          formatHours(new Date(upcomingBooking.bookingEndTime))
                        }}:{{
                          formatMinutes(
                            new Date(upcomingBooking.bookingEndTime)
                          )
                        }}
                        {{
                          formatTime(new Date(upcomingBooking.bookingEndTime))
                        }}
                      </div>
                    </div>
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-9"
                      />
                      <div>{{ upcomingBooking.bookingAmount }} USD</div>
                    </div>
                  </div>

                  <div
                    class="div-block-25 margin-booking"
                    v-if="upcomingOpen && isSelected === index"
                  >
                    <div class="professional-detail-wrapper">
                      <div class="professional-name-wraper">
                        <div
                          class="text-block-25"
                          v-if="upcomingBooking.type === 'PROFESSIONAL'"
                        >
                          Client:
                        </div>
                        <div
                          class="text-block-25"
                          v-if="upcomingBooking.type === 'CUSTOMER'"
                        >
                          Professional:
                        </div>
                        <div class="div-block-26">
                          <div>
                            <img
                              v-if="upcomingBooking.type === 'PROFESSIONAL'"
                              width="45"
                              loading="lazy"
                              :src="
                                upcomingBooking.customerProfilePicture ||
                                  require('@/assets/timeslot-images/profileImg.svg')
                              "
                              alt=""
                              class="image-10"
                            />
                            <img
                              v-if="upcomingBooking.type === 'CUSTOMER'"
                              width="45"
                              loading="lazy"
                              :src="
                                upcomingBooking.professionalProfilePicture ||
                                  require('@/assets/timeslot-images/profileImg.svg')
                              "
                              alt=""
                              class="image-10"
                            />
                          </div>
                          <div>
                            <div
                              class="text-block-26"
                              v-if="upcomingBooking.type === 'PROFESSIONAL'"
                            >
                              {{ upcomingBooking.customerName }}
                            </div>
                            <div
                              class="text-block-26"
                              v-if="upcomingBooking.type === 'CUSTOMER'"
                            >
                              {{ upcomingBooking.professionalName }}
                            </div>
                            <div v-if="upcomingBooking.type === 'PROFESSIONAL'">
                              {{ upcomingBooking.customerInterest }}
                            </div>
                            <div v-if="upcomingBooking.type === 'CUSTOMER'">
                              {{ upcomingBooking.professionalSubCategory }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="professional-name-wraper">
                        <div class="text-block-25">Meeting Link</div>
                        <div class="div-block-26">
                          <div>
                            <div class="text-block-26">
                              <a
                                v-if="upcomingBooking.type === 'PROFESSIONAL'"
                                class="meeting-link"
                                :href="upcomingBooking.bookingProfessionalLink"
                              >
                                {{ upcomingBooking.bookingProfessionalLink }}
                              </a>
                              <a
                                v-if="upcomingBooking.type === 'CUSTOMER'"
                                class="meeting-link"
                                :href="upcomingBooking.bookingCustomerLink"
                              >
                                {{ upcomingBooking.bookingCustomerLink }}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="professional-name-wraper">
                        <div
                          class="text-block-25"
                          v-if="upcomingBooking.type === 'PROFESSIONAL'"
                        >
                          Client’s Timezone
                        </div>
                        <div
                          class="text-block-25"
                          v-if="upcomingBooking.type === 'CUSTOMER'"
                        >
                          Professional’s Timezone
                        </div>
                        <div class="div-block-26">
                          <div>
                            <div
                              class="text-block-26"
                              v-if="upcomingBooking.type === 'PROFESSIONAL'"
                            >
                              {{ upcomingBooking.customerTimezone }}
                            </div>
                            <div
                              class="text-block-26"
                              v-if="upcomingBooking.type === 'CUSTOMER'"
                            >
                              {{ upcomingBooking.professionalTimezone }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="professional-name-wraper">
                        <div class="text-block-25">Topic</div>
                        <div class="div-block-26">
                          <div>
                            <div class="text-block-26">
                              {{ upcomingBooking.bookingTopic }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="professional-name-wraper">
                        <div class="text-block-25">Your Message</div>
                        <div class="div-block-26">
                          <div>
                            <p class="paragraph-2">
                              {{ upcomingBooking.bookingMessage }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="div-block-27">
                    <div
                      data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e5"
                      class="button-4 outline w-button"
                      @click="openDetails(index)"
                      v-if="!upcomingOpen || isSelected !== index"
                    >
                      View details
                    </div>
                    <div
                      data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e5"
                      class="button-4 outline w-button"
                      @click="closeDetails(index)"
                      v-if="upcomingOpen && isSelected === index"
                    >
                      Hide details
                    </div>
                    <!--                    <div-->
                    <!--                      data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e7"-->
                    <!--                      href=""-->
                    <!--                      class="button-4 cancel-copy w-button"-->
                    <!--                    >-->
                    <!--                      Reschedule-->
                    <!--                    </div>-->
                    <div
                      data-w-id="c4f967d2-040f-06e6-a1a0-54155c7905e9"
                      class="button-4-copy outline w-button"
                      @click="activateCancel(upcomingBooking.bookingId)"
                    >
                      Cancel
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            data-w-tab="Tab 3"
            v-if="past"
            :class="past ? 'w-tab-pane w--tab-active' : 'w-tab-pane'"
          >
            <div class="no-update_wrapper" v-if="pastBookings.length === 0">
              <div class="no-update_content">
                <img
                  src="@/assets/timeslot-images/timer.svg"
                  loading="lazy"
                  alt=""
                  width="50"
                  height="50"
                />
                <div class="no-update-yet">
                  <strong>Nothing to show here</strong>
                </div>
                <div class="appointments">
                  <strong>No past bookings</strong>
                </div>
              </div>
            </div>
            <div v-else>
              <div
                class="bookings-list-wrapper bookings"
                v-for="(pastBooking, index) in pastBookings"
                :key="index"
              >
                <div class="div-block-24">
                  <div class="text-block-24">
                    Consultation Session with
                    <router-link
                      v-if="pastBooking.type === 'PROFESSIONAL'"
                      :to="`/clients/${pastBooking.bookingCustomerId}`"
                      class="link-5"
                      >{{ pastBooking.customerName }}</router-link
                    >
                    <router-link
                      v-if="pastBooking.type === 'CUSTOMER'"
                      :to="
                        `/professionals/${pastBooking.bookingProfessionalId}`
                      "
                      class="link-5"
                      >{{ pastBooking.professionalName }}</router-link
                    >
                  </div>
                  <div class="div-block-22">
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-7"
                      />
                      <div>
                        {{
                          new Date(pastBooking.bookingStartTime.slice(0, 10))
                            .toString()
                            .slice(0, 11)
                        }}
                      </div>
                    </div>
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-8"
                      />
                      <!--                      {{ pastBooking.bookingStartTime.slice(10, 16) }}am - -->
                      <!--                      {{ pastBooking.bookingEndTime.slice(10, 16) }}am-->
                      <div>
                        {{
                          formatHours(new Date(pastBooking.bookingStartTime))
                        }}:{{
                          formatMinutes(new Date(pastBooking.bookingStartTime))
                        }}
                        {{ formatTime(new Date(pastBooking.bookingStartTime)) }}
                        -
                        {{
                          formatHours(new Date(pastBooking.bookingEndTime))
                        }}:{{
                          formatMinutes(new Date(pastBooking.bookingEndTime))
                        }}
                        {{ formatTime(new Date(pastBooking.bookingEndTime)) }}
                      </div>
                    </div>
                    <div class="div-block-23">
                      <img
                        loading="lazy"
                        src="@/assets/timeslot-images/calendar.svg"
                        alt=""
                        class="image-9"
                      />
                      <div>
                        {{ pastBooking.bookingAmount }} USD
                        {{ pastBooking.bookingSlots }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="div-block-25"
                  v-if="upcomingOpen && isSelected === index"
                >
                  <div class="professional-detail-wrapper">
                    <div class="professional-name-wraper">
                      <div
                        class="text-block-25"
                        v-if="pastBooking.type === 'PROFESSIONAL'"
                      >
                        Client:
                      </div>
                      <div
                        class="text-block-25"
                        v-if="pastBooking.type === 'CUSTOMER'"
                      >
                        Professional:
                      </div>
                      <div class="div-block-26">
                        <div>
                          <img
                            v-if="pastBooking.type === 'PROFESSIONAL'"
                            width="45"
                            loading="lazy"
                            :src="
                              pastBooking.customerProfilePicture ||
                                require('@/assets/timeslot-images/profileImg.svg')
                            "
                            alt=""
                            class="image-10"
                          />
                          <img
                            v-if="pastBooking.type === 'CUSTOMER'"
                            width="45"
                            loading="lazy"
                            :src="
                              pastBooking.professionalProfilePicture ||
                                require('@/assets/timeslot-images/profileImg.svg')
                            "
                            alt=""
                            class="image-10"
                          />
                        </div>
                        <div>
                          <div
                            class="text-block-26"
                            v-if="pastBooking.type === 'PROFESSIONAL'"
                          >
                            {{ pastBooking.customerName }}
                          </div>
                          <div
                            class="text-block-26"
                            v-if="pastBooking.type === 'CUSTOMER'"
                          >
                            {{ pastBooking.professionalName }}
                          </div>
                          <div v-if="pastBooking.type === 'PROFESSIONAL'">
                            {{ pastBooking.customerInterest }}
                          </div>
                          <div v-if="pastBooking.type === 'CUSTOMER'">
                            {{ pastBooking.professionalSubCategory }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="professional-name-wraper">
                      <div
                        class="text-block-25"
                        v-if="upcomingBooking.type === 'PROFESSIONAL'"
                      >
                        Client’s Timezone
                      </div>
                      <div
                        class="text-block-25"
                        v-if="upcomingBooking.type === 'CUSTOMER'"
                      >
                        Professional’s Timezone
                      </div>
                      <div class="div-block-26">
                        <div>
                          <div
                            class="text-block-26"
                            v-if="upcomingBooking.type === 'PROFESSIONAL'"
                          >
                            {{ upcomingBooking.customerTimezone }}
                          </div>
                          <div
                            class="text-block-26"
                            v-if="upcomingBooking.type === 'CUSTOMER'"
                          >
                            {{ upcomingBooking.professionalTimezone }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="professional-name-wraper">
                      <div class="text-block-25">Topic</div>
                      <div class="div-block-26">
                        <div>
                          <div class="text-block-26">
                            {{ pastBooking.bookingTopic }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="professional-name-wraper">
                      <div class="text-block-25">Your Message</div>
                      <div class="div-block-26">
                        <div>
                          <p class="paragraph-2">
                            {{ pastBooking.bookingMessage }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  data-w-id="86441311-6c91-7119-f345-f7dd99793197"
                  class="button-4 view w-button"
                  style="margin-bottom: 20px;"
                  v-if="!upcomingOpen || isSelected !== index"
                  @click="openDetails(index)"
                >
                  View details
                </div>
                <div
                  data-w-id="86441311-6c91-7119-f345-f7dd99793199"
                  v-if="upcomingOpen && isSelected === index"
                  @click="closeDetails(index)"
                  class="button-4 hide w-button"
                  style="margin-bottom: 20px;"
                >
                  Hide details
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <UpdateTimezoneModal v-if="time" :cancel="closeTime" />
    <CancelMessageModal
      v-if="cancelBooking && !cancelSuccess"
      :loading="loadCancel"
      :button-action="cancelBookingAction"
      :title="'Cancel Booking'"
      :message="'Do you want to cancel this booking?'"
      :cancel="deactivateCancel"
    />
    <SuccessMessageModal
      v-if="cancelSuccess"
      :cancel="closeCancelSuccess"
      :button-action="closeCancelSuccess"
    />
    <template v-slot:right-side-nav>
      <ProfRightSideMenu />
    </template>
  </TimeslotDashboardLayout>
</template>

<script>
import TimeslotDashboardLayout from "@/views/timeslot/TimeslotDashboardLayout";
import BookingRequest from "@/model/requests/BookingRequest";
import { mapState } from "vuex";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import UpdateTimezoneModal from "@/components/modal/UpdateTimezoneModal";
import moment from "moment";
import CancelMessageModal from "@/components/modal/CancelMessageModal";
import SuccessMessageModal from "@/components/modal/SuccessMessageModal";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import ProfRightSideMenu from "@/views/timeslot/ProfRightSideMenu";

export default {
  name: "ProfessionalBookings",
  components: {
    ProfRightSideMenu,
    TimeslotDashboardLayout,
    UpdateTimezoneModal,
    CancelMessageModal,
    SuccessMessageModal
  },
  data() {
    return {
      loadCancel: false,
      cancelBooking: false,
      upcoming: true,
      pending: false,
      past: false,
      subscribe: false,
      show: false,
      show2: false,
      show3: false,
      show4: false,
      bar: true,
      cross: false,
      readProfModel: BookingRequest.readByProfessionalId,
      time: false,
      isSelected: null,
      upcomingOpen: false,
      cancelModel: BookingRequest.cancel,
      readModel: BookingRequest.readByCustomerId,
      filterType: "All"
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      profBookingInfo: state => state.booking.profBookingInfo,
      bookingInfo: state => state.booking.bookingInfo,
      bookingInfoAlt: state => state.booking.singleBooking,
      professionalInfo: state => state.professional.professionalInfo,
      subscriptions: state => state.subscription.professionalSubscriptions,
      activeBooking: state => state.booking.activeBooking,
      cancelSuccess: state => state.booking.cancelSuccess,
      customerInfo: state => state.customer.customerInfo,
      professionalId: state => state.professional.professionalId,
      customerToProfessionalId: state =>
        state.professional.customerToProfessionalId
    }),
    upcomingBookings() {
      return this.bookingInfo.filter(item => item.bookingStatus === "UPCOMING");
    },
    pastBookings() {
      return this.bookingInfo.filter(item => item.bookingStatus === "PAST");
    }
  },
  methods: {
    goToDashboard() {
      RouterUtils.changeRouteUrlTo("/professional-dashboard");
    },
    activateCancel(value) {
      this.cancelBooking = true;
      StoreUtils.commit("booking/updateActiveBooking", value);
    },
    deactivateCancel() {
      this.cancelBooking = false;
    },
    cancelBookingAction() {
      this.cancelModel.bookingId = this.activeBooking;
      this.loadCancel = true;
      return StoreUtils.dispatch(
        "booking/cancelBooking",
        this.cancelModel
      ).then(() => {
        this.cancelBooking = false;
      });
    },
    closeCancelSuccess() {
      StoreUtils.commit("booking/updateCancelSuccess", false);
      // if (this.userInfo.professional.professionalId) {
      //   this.readModel.bookingProfessionalId = this.userInfo.professional.professionalId;
      // } else {
      //   this.readModel.bookingProfessionalId = this.customerToProfessionalId;
      // }
      this.readModel.bookingCustomerId = this.userInfo.customerId;
      StoreUtils.dispatch("booking/readBookingByCustomerId", this.readModel);
    },
    goToProfile() {
      RouterUtils.changeRouteUrlTo(`/professionals/${this.professionalId}`);
    },
    logout() {
      StoreUtils.dispatch(StoreUtils.actions.auth.LOGOUT);
    },
    showNav() {
      this.cross = true;
      this.bar = false;
    },
    closeNav() {
      this.bar = true;
      this.cross = false;
    },
    formattedDate(date) {
      return moment(date).format("LT");
    },
    formatDate(date) {
      return moment(date).format("ll");
    },
    formatTime(date) {
      return moment(date).format("a");
    },
    formatMinutes(date) {
      return moment(date).format("mm");
    },
    formatHours(date) {
      return moment(date).format("h");
    },
    openUpcoming() {
      this.upcoming = true;
      this.pending = false;
      this.past = false;
      this.subscribe = false;
    },
    openPending() {
      this.upcoming = false;
      this.pending = true;
      this.past = false;
      this.subscribe = false;
    },
    openPast() {
      this.pending = false;
      this.past = true;
      this.upcoming = false;
      this.subscribe = false;
    },

    openSubscribe() {
      this.pending = false;
      this.past = false;
      this.upcoming = false;
      this.subscribe = true;
    },
    toggleUpcoming(index) {
      this.isSelected = index;
      this.upcomingOpen = !this.upcomingOpen;
    },
    openDetails(index) {
      this.isSelected = index;
      this.upcomingOpen = true;
    },
    closeDetails(index) {
      this.isSelected = index;
      this.upcomingOpen = false;
    },
    toggleShow() {
      this.show = !this.show;
    },
    toggleShow2() {
      this.show2 = !this.show2;
    },
    toggleShow3() {
      this.show3 = !this.show3;
    },
    toggleShow4() {
      this.show4 = !this.show4;
    },
    openTime() {
      this.time = true;
    },
    closeTime() {
      this.time = false;
    }
  },
  watch: {
    filterType(newValue) {
      if (newValue.toLowerCase() === "client") {
        StoreUtils.commit(
          "booking/updateBookingInfo",
          (this.bookingInfo = this.bookingInfoAlt.filter(
            item => item.type.toLowerCase() === "professional"
          ))
        );
      } else if (newValue.toLowerCase() === "personal") {
        StoreUtils.commit(
          "booking/updateBookingInfo",
          (this.bookingInfo = this.bookingInfoAlt.filter(
            item => item.type.toLowerCase() === "customer"
          ))
        );
      } else if (newValue.toLowerCase() === "all") {
        StoreUtils.commit(
          "booking/updateBookingInfo",
          (this.bookingInfo = this.bookingInfoAlt)
        );
      }
    }
  },
  mounted() {
    // if ("professional" in this.userInfo) {
    //   this.readModel.bookingProfessionalId = this.userInfo.professional.professionalId;
    // } else {
    //   this.readModel.bookingProfessionalId = this.customerToProfessionalId;
    // }
    // // this.readModel.bookingProfessionalId = this.professionalInfo.professionalId;
    // StoreUtils.dispatch(
    //   StoreUtils.actions.booking.READ_BY_BOOKING_PROFESSIONAL_ID,
    //   this.readModel
    // );
    this.readModel.bookingCustomerId = this.userInfo.customerId;
    StoreUtils.dispatch(
      StoreUtils.actions.booking.READ_BY_BOOKING_CUSTOMER_ID,
      this.readModel
    );
  }
};
</script>

<style scoped>
.booking-heading {
  display: flex;
  justify-content: space-between;
}
.booking-details {
  cursor: pointer;
}
.margin-booking {
  margin-top: 20px;
}
.meeting-link {
  color: black;
}
.filter-size {
  width: 15%;
  margin-right: 20px;
}
.prof-booking-width {
  width: 58%;
}

@media only screen and (max-width: 790px) {
  .filter-size {
    width: 35%;
    margin-right: 0;
  }
  .prof-booking-width {
    width: 100%;
    margin-left: 25px;
  }
}
@media only screen and (min-width: 791px) and (max-width: 912px) {
  .filter-size {
    width: 20%;
    margin-right: 0;
  }
  .prof-booking-width {
    width: 100%;
    margin-left: 25px;
  }
}
</style>
